<template>
  <div class='home'>
    <WorkshopList v-show='listView' @newWorkshop='onClickNewFromList' @editWorkshop='onClickEditFromList' :scroll="corY" ref='refreshList'/>
    <WorkshopForm v-show='formView' :workshop='workshop' @backClicked='onBackChild'/>
  </div>
</template>

<script>
// @ is an alias to /src
import WorkshopList from '@/components/workshop/WorkshopList.vue'
import WorkshopForm from '@/components/workshop/WorkshopForm.vue'
import { mapState } from 'vuex'
import { getHeader, workshopUrl } from '../config'
import Axios from 'axios'

export default {
  name: 'Workshop',
  components: {
    WorkshopList,
    WorkshopForm
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      woTermList: state => state.woTerms.woTermList
    })
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      workshop: {
        id: null,
        type_id: null,
        workshop_no: null,
        date_in: null,
        date_out: null,
        customer_no: null,
        customer: {
          name: null,
          phone: null,
          address: null
        },
        customer_note: null,
        work_order: null,
        notes: null,
        get_backup: false,
        change_part: false,
        engineer_id: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        specification: null,
        status: null,
        branch_no: null,
        work_start: null,
        work_finish: null,
        receiver_id: null,
        server_id: null,
        hours: null,
        next_service: null,
        schedule_date: null,
        due_date: null,
        sale_no: null,
        company_no: null,
        mechanic_id: null,
        lock: false,
        items: [{
          id: null,
          workshop_no: null,
          product_no: null,
          product_sku: null,
          qty: null,
          serial_number: null,
          branch_no: null,
          description: null,
          sec_serial_number: null,
          hours: '',
          kilometer: '',
          mill: ''
        }],
        details: [{
          id: null,
          workshop_no: null,
          sale_date: null,
          branch_no: null,
          product_no: null,
          product_sku: null,
          description: null,
          qty: null,
          uom_id: null,
          serial_number: null,
          sec_serial_number: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          warehouse_no: null,
          status: null,
          estimated_date: null,
          type: null,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: null,
            price: '0'
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
    }
  },
  methods: {
    getEditSales: function (id) {
      Axios.get(workshopUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.workshop = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.workshop = value
    },
    onClickNewFromList: function () {
      this.listView = false
      this.formView = true
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const date = new Date().toISOString()
      this.workshop = {
        id: null,
        type_id: '1',
        workshop_no: null,
        date_in: date,
        date_out: null,
        customer_no: '_________________',
        customer: {
          name: '_________________',
          phone: '_________________',
          address: '_________________'
        },
        customer_note: null,
        work_order: null,
        notes: null,
        get_backup: false,
        change_part: false,
        engineer_id: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        specification: null,
        status: 'open',
        branch_no: null,
        work_start: null,
        work_finish: null,
        receiver_id: null,
        server_id: null,
        hours: null,
        next_service: null,
        schedule_date: date,
        due_date: null,
        sale_no: null,
        company_no: this.authUser.company_no,
        mechanic_id: null,
        lock: false,
        items: [{
          workshop_no: null,
          product_no: null,
          product_sku: null,
          qty: null,
          serial_number: null,
          branch_no: null,
          description: null,
          sec_serial_number: null,
          hours: '',
          kilometer: '',
          mill: ''
        }],
        details: [],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
    },
    onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.workshop = {
        id: null,
        type_id: null,
        workshop_no: null,
        date_in: null,
        date_out: null,
        customer_no: null,
        customer: {
          name: null,
          phone: null,
          address: null
        },
        customer_note: null,
        work_order: null,
        notes: null,
        get_backup: false,
        change_part: false,
        engineer_id: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        specification: null,
        status: null,
        branch_no: null,
        work_start: null,
        work_finish: null,
        receiver_id: null,
        server_id: null,
        hours: null,
        next_service: null,
        schedule_date: null,
        due_date: null,
        sale_no: null,
        company_no: null,
        mechanic_id: null,
        lock: false,
        items: [{
          id: null,
          workshop_no: null,
          product_no: null,
          product_sku: null,
          qty: null,
          serial_number: null,
          branch_no: null,
          description: null,
          sec_serial_number: null,
          hours: '',
          kilometer: '',
          mill: ''
        }],
        details: [{
          id: null,
          workshop_no: null,
          sale_date: null,
          branch_no: null,
          product_no: null,
          product_sku: null,
          description: null,
          qty: null,
          uom_id: null,
          serial_number: null,
          sec_serial_number: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          warehouse_no: null,
          status: null,
          estimated_date: null,
          type: null,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: null,
            price: '0'
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
      this.$store.dispatch('getProductListSelect')
      this.$refs.refreshList.refreshList()
      window.scrollTo(this.corX, this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getProductListSelect')
    this.$store.dispatch('getWorkshopTypeList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
    var param = this.$route.query.workshop
    if (typeof param !== 'undefined') {
      this.getEditSales(param)
    }
  }
}
</script>
